import React, { useEffect, useState } from "react";
import { Page, PendingButton, LoadingMsg } from "components/common";
import moment from "moment";
import { FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import { Trans } from "react-i18next";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import { Table } from "reactstrap";
import { useHistory } from 'react-router';
import { useXeroClient } from "hooks";
import Select from "react-select";


const ContactTransactions = ({ client, t, selectedOrganisation }) => {
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(false);

  const [contacts, setContacts] = useState([])

  const history = useHistory();
  const xero = useXeroClient();


  const [item, setItem] = useState({});

  const getReport = () => {
    for(var key in item) {
      if(item[key] === "" || item[key] === null) {
        NotificationManager.error(t(`All form values are required`))
        return
      }
  }
    setHistory()
    loadReport()
  }

  const loadReport = async () => {
    setPending(true);
    try {
      let resp = await client
        .get(`xero_actions/${selectedOrganisation.id}/contact_transactions`, {
          params: item,
        })
        .get("data");
      setData(resp);
    } catch (ex) {
      if (ex.response && ex.response.data) {
        NotificationManager.error(t(ex.response.data?.message));
      } else {
        NotificationManager.error(t("An unexpected error occurred"));
      }
    }
    setPending(false);
  };

  useEffect(() => {

    async function fetchData() {
      const [contacts] = await Promise.all([
        xero.get(`contacts`).get("data").map((x) => ({
            label: x.Name,
            value: x.ContactID,
          }))
      ]);
      setContacts(contacts);
    }

    fetchData();

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const fromDate = params.get('from')
    const toDate = params.get('to')
    setItem((old) => (
      {...old, 'fromDate':fromDate? fromDate : moment().startOf("month").format("YYYY-MM-DD"),
      'toDate':toDate? toDate : moment().endOf("month").format("YYYY-MM-DD")
    }
  ))
  }, []);

  const setHistory = () => {
    history.push({
      pathname: '/reports/contact_transactions',
      search: `?from=${item.fromDate}&to=${item.toDate}`
    })
  }

 

  return (
    <Page title="Contact Transactions" className="inv-table">
      <div className="d-print-none inv-tabs ">
        <div className="mt-3">
          <Row>
            <Col className="col-3">
              <FormGroup>
              <Label>
                <Trans>Contact</Trans>
              </Label>
              <Select placeholder={t('Select...')} clearable={false} options={contacts} value={item.contact} onChange={(e) => setItem({...item, contact:e.value})} />
            </FormGroup>
            </Col>
            <Col className="col-2">
              <FormGroup className="">
              <Label>
                <Trans>From Date</Trans>
              </Label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={item.fromDate ? moment(item.fromDate) : null}
                className="form-control"
                dateFormat="D MMM YYYY"
                onChange={(value) => {
                  setItem({...item, fromDate:value? moment(value).format("YYYY-MM-DD") : null});
                }}
              />
            </FormGroup>
            </Col>
            <Col className="col-2">
              <FormGroup className="">
              <Label>
                <Trans>To Date</Trans>
              </Label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={item.toDate ? moment(item.toDate) : null}
                className="form-control"
                dateFormat="D MMM YYYY"
                onChange={(value) => {
                  setItem({...item, toDate:value? moment(value).format("YYYY-MM-DD") : null});
                }}
              />
            </FormGroup>
            </Col>
            <Col className="col-3 d-flex align-items-end">
              <FormGroup check className="" style={{paddingBottom:"12px"}}>
                <Input name="prepayments" type="checkbox" checked={item.prepayments} onChange={(e) => setItem({...item, prepayments:!item.prepayments})} />
                <Label check htmlFor="prepayments"><Trans>Include Prepayments</Trans></Label>
              </FormGroup>
            </Col>
            <Col className="col-2">
              <FormGroup>
                <Label>&nbsp;</Label>
                <PendingButton
                  color="primary"
                  size="sm"
                  className="d-block"
                  onClick={getReport}
                  pending={pending}
                >
                  <Trans>Update</Trans>
                </PendingButton>
              </FormGroup>
            </Col>
        </Row>
        </div>
      </div>
      {/*data ? <SalesTaxContainer report={data} /> : null*/}
      {pending ? (
        <LoadingMsg />
      ) : (
        <div>
            {data && data?.MainRows && 
            <div className="">
              <div className="header mt-3 border px-3 pt-3 pb-2">
                  <p className="h4 mb-3">{data.ReportTitles[0]}</p>
                  <p>{data.ReportTitles[1]}</p>
                  <p>{data.ReportTitles[2]}</p>
              </div>
              <div className="border my-3 p-3">
                <Table responsive className="text-left">
                    <thead>
                      <tr>
                        {data?.MainRows?.Header?.map((i) => (
                            <th className="text-left h5">
                              <Trans>{i.Value}</Trans>
                            </th>                
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data?.MainRows?.Rows.length> 0? 
                        data.MainRows.Rows.map((row) => (
                        <tr>
                          {row?.Cells?.map((cell) =>(
                            <td className={`text-left ${row.RowType=='SummaryRow' && 'font-weight-bold h5'}`}>
                              <Trans>{cell.Value}</Trans>
                            </td>
                          ))  
                        }
                        </tr>
                        ))
                        :
                        <tr>
                          <td className="text-center p-2" colspan="2">
                            <Trans>No Transactions</Trans>
                          </td>
                        </tr>
                        
                      }
                    </tbody>
                </Table> 
              </div>
            </div>
            }
        </div>
      )}
    </Page>
  );
};


export default ContactTransactions;
